// this a new copy of the src/constants/OrderDeliveryMethodType.ts
export const DELIVERY_METHOD_OPTION = {
  delivery: 'delivery',
  marketplace: 'marketplace',
  pickup: 'pickup',
} as const;
